import { HandoverDashboardTemplate } from "app/features/shiftHandoverDashboard/templates/HandoverDashboardTemplate";

export default function ShiftHandoverScreen() {
  return <HandoverDashboardTemplate />;
}
